import React from "react";
import styles from "./client-data-block.module.scss";
import User2Icon from "../../../../icons/subscription-status/user-2.icon";

export const ClientDataBlock = () => {
  return (
    <article className={styles.container}>
      <header className={styles.header}>
        <h2 className={styles.title}>
          5 Days Requested
        </h2>

        <div className={styles.userInfo}>
          <span className={styles.userInfoText}>
            by
          </span>

          <div className={styles.userIcon}>
            <User2Icon aria-hidden="true" />
          </div>
          <span className={styles.userInfoText}>
            Sarah Connor
          </span>
        </div>
      </header>

      <p className={styles.description}>
        &quot;Client requested more time to evaluate features&quot;
      </p>
    </article>
  );
};